import React from 'react';
import PropTypes from 'prop-types';
import { TextMedium } from '../../../../common/text';
import { RoundSquare, LegendItem, Legend } from '../../../Timeline/Legend.styles';
import { ChartHeader, RowHeaderBase, RowItem } from '../../ChartRowAndHeader.styles';

export const PersonsOffshoreChartRowHeader = ({ width, chartWidth, theme }) => (
    <ChartHeader chartWidth={chartWidth}>
        <RowHeaderBase width={width}>
            <RowItem>
                <TextMedium bold>PERSON ID</TextMedium>
            </RowItem>
        </RowHeaderBase>
        <Legend>
            <LegendItem>
                <RoundSquare color={theme.color.blue} />
                <TextMedium>On Vessel</TextMedium>
            </LegendItem>
            <LegendItem>
                <RoundSquare color={theme.color.green} />
                <TextMedium>On Turbine</TextMedium>
            </LegendItem>
        </Legend>
    </ChartHeader>
);

PersonsOffshoreChartRowHeader.displayName = 'PersonsOffshoreChartRowHeader';

PersonsOffshoreChartRowHeader.propTypes = {
    width: PropTypes.number,
    theme: PropTypes.object,
};

PersonsOffshoreChartRowHeader.defaultProps = {};
